import { render, staticRenderFns } from "./IndexBlank.vue?vue&type=template&id=f62cf01e&"
import script from "./IndexBlank.vue?vue&type=script&lang=js&"
export * from "./IndexBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports